const BRING_PROD_SITEIMPROVE_KEY = '6015663'

export const initializeSiteAnalytics = () => {
  const sz = document.createElement('script')
  sz.type = 'text/javascript'
  sz.async = true
  sz.src = `//siteimproveanalytics.com/js/siteanalyze_${BRING_PROD_SITEIMPROVE_KEY}.js`
  document.body.appendChild(sz)
}

export type PageView = {
  pageUrl: string
  pageTitle: string
  previousUrl?: string
}

// More reading on dynamic page tracking: https://help.siteimprove.com/support/solutions/articles/80000448441
export const siteAnalyticsTrackPageViewDynamically = (pageView: PageView) => {
  if (window._sz instanceof Array && pageView.previousUrl && pageView.previousUrl !== pageView.pageUrl) {
    window._sz.push([
      'trackdynamic',
      {
        url: pageView.pageUrl,
        title: pageView.pageTitle,
        ref: pageView.previousUrl
      }
    ])
  }
}

declare global {
  interface Window {
    _sz: any
  }
}
